<template>
	<div class="row centered">
		<AppTable ref="invoices-table"
			v-if="userStore.currBusinessId"
			:fetch-function="administrationStore.getFilteredBusinessToCustomerInvoices"
			:filters="filters"
			:table-headings="tableHeadings"
			:title="getString('b2c_invoices')"
			:total-items="administrationStore.businessBusinessToCustomerInvoicesTotal || 0"
			:items="administrationStore.businessBusinessToCustomerInvoices || []"
			initial-sort-field="date"
			:initial-sort-asc="false"
			allow-download
		  	no-export-type-popup
		 	@export="showExportPopup"
			@failed-fetch="details=>{$emit('failed-fetch', details)}" >

			<template #actions="{item}">
				<div class="row align-center centered">
					<AppTableButtonGroup v-if="isFailedState(item.state)" :buttons="buttonsActionsFailedState(item)" :item="item" @picked-switch-customer="clickSwitchCustomer(item.invoice_id)" @retry-invoice="retryInvoice(item.invoice_id)" @picked-edit-customer="editCustomer(item.customer_id, item.invoice_id)"/>
					<AppTableButtonGroup v-else-if="!!item.url" :buttons="buttonsActions(item)" :item="item" @picked-download="openUrl(item.url)" @picked-print="printInvoice(item.invoice_id)" @emit-credit-note="showCreditNotePopup(item.invoice_id)"/>
					<div class="no-download" v-else>N/A</div>
				</div>
			</template>

			<template #xml="{item}">
				<div class="row align-center centered">
					<AppTableButtonGroup  v-if="!!item.apifattura_invoice_id" :buttons="buttonsXml" :item="item" @picked-download-xml="downloadInvoiceXml(item)"/>
					<div class="no-download" v-else>N/A</div>
				</div>
			</template>

		</AppTable>
		<AppBottomSheet :forceWidth="bottomSheetWidth"  :active="!!companyId" @toggling-popup="togglingPopupCompanyDetails">
			<div class="customers-display" v-if="companyId">
				<ModalHeader
					:button-text="getString('save')"
					@clickButton="updateCustomer"
					:title="getString('edit_x', [this.counterStore.selectedCustomer ? this.counterStore.selectedCustomer.name : '-'])"
				/>
				<CustomersCompanyEditDetails no-delete ref="company-details" :company-id="companyId" />
			</div>
		</AppBottomSheet>
		<CustomersPicker companies-only :active="!!switchCustomerInvoiceId" @toggling-popup="togglingPopupPicker" @picked-customer="pickedCustomer" />
		<AppPopup
			:title="getString('confirm_switch_customer')"
			:body-text="getString('confirm_switch_customer_explain', confirmSwitchBodyTextParams)"
			:buttons="popupDeleteButtons"
			ref="confirm-switch"
			prevent-overlay-dismiss
		/>
		<AppPopup
			ref="export-popup"
			:title="getString('export_type_title')"
			:buttons="exportButtons"
		/>
		<AppPopup
			:title="getString('confirm_credit_note')"
			:body-text="getString('confirm_credit_note_explain')"
			:buttons="popupCreditNoteButtons"
			ref="confirm-credit-note"
			prevent-overlay-dismiss
		/>
	</div>
</template>

<script>
import API from '@/shared/helpers/API.js';
import AppTable from "@/shared/components/AppTable.vue";
import {useUserStore, useAdministrationStore, useOrdersStore, useCustomersStore, useCounterStore} from "@/console-new/stores";
import {useCurrencyStore, useLanguageStore, useNotificationStore, useScriptStore} from "@/shared/stores";
import {exportToFile} from "@/shared/helpers/excel";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppButton from "@/console-signup-speedy/App.vue";
import AppList from "@/shared/components/AppList.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import CustomersCompanyEditDetails from "@/console-new/components/ops/CustomersCompanyEditDetails.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import CustomersPicker from "@/console-new/components/ops/CustomersPicker.vue";
import AppTableButtonGroup from "@/shared/components/AppTableButtonGroup.vue";

export default {
	setup() {
		const userStore = useUserStore();
		const counterStore = useCounterStore();
		const administrationStore = useAdministrationStore();
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const customersStore = useCustomersStore();
		const ordersStore = useOrdersStore();
		const currencyStore = useCurrencyStore();
		const scriptStore = useScriptStore();
		return {userStore, counterStore, currencyStore, ordersStore, administrationStore, languageStore, getString: languageStore.getString, customersStore, notificationStore, scriptStore}
	},
	name: "BusinessToCustomerInvoicesTable",
	emits: ["failed-fetch"],
	mixins: [WindowWidth],
	components: {
		AppTableButtonGroup,
		AppPopup, CustomersCompanyEditDetails, CustomersPicker, AppButton, AppList, ModalHeader, AppBottomSheet, AppButtonIcon, AppTable},
	props: {

	},
	data() {
		return {
			loadingCustomersCompanies: false,
			loadingSwitchCustomer: false,
			loadingSingleCustomer: false,
			filters: [
				{
					type: "date",
					key: 'date',
					tableName: 'orders_invoices',
					text: this.getString('date'),
					finalValue: ''
				},
				{
					type: "price",
					key: "amount",
					text: this.getString('amount'),
					active: false,
					value: null,
					activeItem: 0,
					finalValue: '',
				},
				{
					type: "checklist",
					key: "payment_type",
					text: this.getString('payment'),
					values: [this.getString('payment_type_stripe'), this.getString('payment_type_cash'), this.getString('payment_type_btc'), this.getString('payment_type_satispay'), this.getString('payment_type_klarna'), this.getString('payment_type_ticket'), this.getString('payment_type_paylater'), this.getString('payment_type_check'), this.getString('payment_type_wire'), this.getString('payment_type_multi'), this.getString('payment_type_manual'), this.getString('payment_type_external')],
					keysArray: [
						'stripe',
						'cash',
						'btc',
						'satispay',
						'klarna',
						'ticket',
						'paylater',
						'check',
						'wire',
						'multi'
					],
					active: false,
					selectedIndexes: [],
					finalValue: '',
				},
				{
					type: "checklist",
					key: "from_receipt",
					text: this.getString('from_receipt'),
					values: [this.getString('yes'), this.getString('no')],
					keysArray: [1, 0],
					active: false,
					selectedIndexes: [],
					finalValue: '',
				},
				{
					type: "checklist",
					key: "document_type",
					text: this.getString('type'),
					values: ['invoice', 'credit_note'].map(t => this.getString(t)),
					keysArray: ['invoice', 'credit_note'],
					selectedIndexes: [],
				},
			],
			tableHeadings: [
				{
					text: this.getString('date'),
					cols: 1,
					sortable: true,
					active: true,
					sortAsc: false,
					fieldName: 'date',
				},
				{
					text: this.getString('number'),
					cols: 1,
					fieldName: 'numero'
				},
				{
					text: this.getString('amount'),
					cols: 1,
					sortable: true,
					fieldName: 'amount',
				},
				{
					text: this.getString('payment'),
					cols: 1,
					fieldName: 'payment_type',
					formatter: payment_type => this.getString(payment_type ? 'payment_type_' + payment_type : ''),
				},
				{
					text: this.getString('type'),
					cols: 1,
					fieldName: 'reference_invoice_id',
					formatter: reference_invoice_id => this.getString(reference_invoice_id ? 'credit_note' : 'invoice'),
				},
				{
					text: this.getString('customer'),
					cols: 1,
					fieldName: 'name',
				},
				{
					text: this.getString('state'),
					cols: 1,
					fieldName: 'state_readable',
				},
				{
					text: this.getString('error'),
					cols: 2,
					fieldName: 'error_readable',
				},
				{
					text: this.getString('actions'),
					cols: 1,
					fieldName: 'actions',
					slotName: 'actions',
				},
				{
					text: "XML",
					cols: 1,
					fieldName: 'xml',
					slotName: 'xml',
				},
			],
			companyId: null,
			retryingInvoiceId: null,
			emittingCreditNoteId: null,
			pendingCreditNoteInvoiceId: null,
			editCustomerInvoiceId: null,
			switchCustomerInvoiceId: null,
			targetSwitchNewCompanyId: null,
		}
	},
	computed: {
		exportButtons() {
			return [
				{
					text: this.getString("export_type_csv"),
					callback: ()=>{
						this.exportInvoices("csv");
						this.dismissExportPopup();
					}
				},
				{
					text: this.getString("export_type_excel"),
					callback: ()=>{
						this.exportInvoices("xlsx");
						this.dismissExportPopup();
					}
				},
				{
					text: "XML",
					callback: ()=>{
						this.downloadInvoicesXml();
						this.dismissExportPopup();
					}
				}
			]
		},
		loadingFailedInvoice() {
			return !!this.retryingInvoiceId || this.loadingSwitchCustomer || this.loadingCustomersCompanies;
		},
		buttonsXml() {
			return [{
				iconName: "icon-download-blue",
				emitName: "picked-download-xml",
				title: this.getString('download_xml')
			}
		]},
		confirmSwitchBodyTextParams() {
			if(!this.switchCustomerInvoiceId || !this.administrationStore.b2cInvoicesIds[this.switchCustomerInvoiceId]
				|| !this.targetSwitchNewCompanyId || !this.customersStore.companiesIds[this.targetSwitchNewCompanyId]) {
				return [];
			}
			let currentInvoice = this.administrationStore.b2cInvoicesIds[this.switchCustomerInvoiceId];
			let newCompany = this.customersStore.companiesIds[this.targetSwitchNewCompanyId];
			return [
				newCompany.name,
				currentInvoice.date.toLocaleString('it', {year: '2-digit', month: '2-digit', day: 'numeric',hour: '2-digit', minute:'2-digit', hour12: false}),
				this.currencyStore.readableCurrencyValue(currentInvoice.amount)
			]
		},
		popupDeleteButtons() {
			return [
				{text: this.getString('cancel'), callback: null, negative: true, loading: this.loadingSwitchCustomer},
				{text: this.getString('ok'), callback: this.confirmSwitchCustomer, loading: this.loadingSwitchCustomer},
			]
		},
		popupCreditNoteButtons() {
			return [
				{text: this.getString('cancel'), callback: null, negative: true, loading: !!this.emittingCreditNoteId},
				{text: this.getString('ok'), callback: this.confirmEmitCreditNote, loading: !!this.emittingCreditNoteId},
			]
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
	},
	methods: {
		showExportPopup() {
			this.$refs['export-popup'].toggleStatus(true);
		},
		dismissExportPopup() {
			this.$refs['export-popup'].toggleStatus(false);
		},
		openUrl(url) {
			window.open(url, '_blank');
		},
		buttonsActions(item) {
			let buttons = [
				{
					iconName: "icon-download-blue",
					emitName: "picked-download",
					title: this.getString('download')
				},
				{
					iconName: "icon-print-order-blue",
					emitName: "picked-print",
					title: this.getString('print')
				},
			];
			// Only show credit note button for confirmed invoices made in the last 365 days
			const oneYearAgo = new Date();
			oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
			if (item.state === 'confirmed' && !item.reference_invoice_id && item.date > oneYearAgo) {
				buttons.push({
					iconName: "icon-refund-blue-new",
					emitName: "emit-credit-note",
					loading: this.emittingCreditNoteId === item.invoice_id,
					disabled: !!this.emittingCreditNoteId,
					title: this.getString('credit_note')
				});
			}
			return buttons;
		},
		buttonsActionsFailedState(item) {
			const invoiceId = item.invoice_id;
			const isCreditNote = !!item.reference_invoice_id;
			let buttons = [
				{
					iconName: "icon-refund-blue-new",
					loading: this.retryingInvoiceId === invoiceId,
					disabled: this.loadingFailedInvoice,
					class: "outline",
					emitName: "retry-invoice",
					title: this.getString('retry')
				},
				{
					iconName: "icon-edit-blue",
					loading: this.editCustomerInvoiceId === invoiceId && this.loadingFailedInvoice,
					disabled: this.loadingFailedInvoice,
					class: "outline",
					emitName: "picked-edit-customer",
					title: this.getString('edit_customer_data'),
					activeFunction: (i) => Number(i.invoice_id) === this.editCustomerInvoiceId,
				},
			];
			// Don't show switch customer for credit notes
			if (!isCreditNote) {
				buttons.push({
					iconName: "Icon-Company-blue",
					loading: this.switchCustomerInvoiceId === invoiceId && this.loadingFailedInvoice,
					disabled: this.loadingFailedInvoice,
					class: "outline",
					emitName: "picked-switch-customer",
					title: this.getString('switch_customer'),
					activeFunction: (i) => Number(i.invoice_id) === this.switchCustomerInvoiceId,
				});
			}
			return buttons;
		},
		clickSwitchCustomer(invoiceId) {
			this.switchCustomerInvoiceId = invoiceId
		},
		togglingPopupPicker(open) {
			if(!open) {
				this.switchCustomerInvoiceId = null;
			}
		},
		confirmSwitchCustomer() {

			if(!this.switchCustomerInvoiceId || !this.administrationStore.b2cInvoicesIds[this.switchCustomerInvoiceId]) {
				this.switchCustomerInvoiceId = null;
				this.$refs['confirm-switch'].toggleStatus(false);
				return
			}

			this.loadingSwitchCustomer = true;
			API.init().switchInvoiceCustomer(this.userStore.currBusinessId, this.switchCustomerInvoiceId, this.targetSwitchNewCompanyId, (response) => {
				this.$refs['confirm-switch'].toggleStatus(false);
				if(response && response.result === 'OK') {
					this.switchCustomerInvoiceId = null;
					this.$refs['invoices-table'].currentFilters = {};
					this.$refs['invoices-table'].changedSort('date', false);
					this.notificationStore.showNotification("generic-success");
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
				this.loadingSwitchCustomer = false;
			});

		},
		pickedCustomer(customer) {
			if(!customer || !customer?.customer_id) {
				this.notificationStore.showNotification("invoice-switch-customer-missing");
				return
			}

			let currentCompany = this.customersStore.companiesIds[customer.customer_id];
			if(!currentCompany) {
				this.customersStore.customersCompanies.push(customer);
			}

			let currentInvoice = this.administrationStore.b2cInvoicesIds[this.switchCustomerInvoiceId];
			if(currentInvoice.customer_id === customer.customer_id) {
				this.notificationStore.showNotification("invoice-switch-same-customer");
				return;
			}
			this.targetSwitchNewCompanyId = customer.customer_id;
			this.$refs['confirm-switch'].toggleStatus(true);
		},
		editCustomer(customerId, invoiceId) {
			if(this.loadingSingleCustomer) { return }
			if(customerId && invoiceId) {
				let finalFn = () => {
					this.companyId = Number(customerId);
					this.editCustomerInvoiceId = Number(invoiceId);
					this.counterStore.selectedCustomer = this.customersStore.companiesIds[customerId];
				}
				if(this.customersStore.companiesIds[customerId]) {
					finalFn();
				} else {
					this.loadingSingleCustomer = true;
					API.init().getCustomer(this.userStore.currBusinessId, customerId, 'company', r => {
						this.loadingSingleCustomer = false;
						this.loading = false;
						if(r && r.result && r.result === "OK") {
							let normalizeCustomer = this.customersStore.normalizeCustomerCompany(r.customer);
							this.customersStore.customersCompanies.push(normalizeCustomer);
							finalFn();
						} else {
							this.notificationStore.showNotification("warning-customer-missing");
						}
					});
				}
			}
		},
		updateCustomer() {
			if(!this.$refs["company-details"].toUpdate) {
				this.companyId = null;
				this.editCustomerInvoiceId = null;
				this.notificationStore.showNotification("no-changes");
			} else {
				this.$refs["company-details"] && this.$refs["company-details"].updateCompany(success=>{
					if(success && this.companyId) {
						this.counterStore.selectedCustomer = this.customersStore.companiesIds[this.companyId];
						this.$refs['invoices-table'].fetchData();
						this.companyId = null;
						this.editCustomerInvoiceId = null;
					}
				});
			}
		},
		togglingPopupCompanyDetails(isOpen) {
			if(!isOpen) {
				this.companyId = null;
				this.editCustomerInvoiceId = null;
				this.counterStore.selectedCustomer = null;
			}
		},
		isFailedState(state) {
			return state === 'failed' || state === 'refused';
		},
		retryInvoice(invoiceId) {
			if (!this.retryingInvoiceId) {
				this.retryingInvoiceId = invoiceId;
				API.init().retryInvoice(this.userStore.currBusinessId, invoiceId, (response) => {
					if (response && response.result === 'OK') {
						this.notificationStore.showNotification("invoice-retry-success");
					} else {
						if(TEST && response.details && response.details.error && response.details.error === "test_mode") {
							this.notificationStore.showNotification("invoice-retry-success");
						} else {
							this.notificationStore.showNotification("invoice-retry-failure");
						}
					}
					this.$refs["invoices-table"].fetchData();
					this.retryingInvoiceId = null;
				});

			}
		},
		showCreditNotePopup(invoiceId) {
			this.pendingCreditNoteInvoiceId = invoiceId;
			this.$refs['confirm-credit-note'].toggleStatus(true);
		},
		confirmEmitCreditNote() {
			if (!this.emittingCreditNoteId && this.pendingCreditNoteInvoiceId) {
				this.emittingCreditNoteId = this.pendingCreditNoteInvoiceId;
				API.init().emitCreditNote(this.userStore.currBusinessId, this.pendingCreditNoteInvoiceId, (response) => {
					this.$refs['confirm-credit-note'].toggleStatus(false);
					if (response && response.result === 'OK') {
						this.notificationStore.showNotification("generic-success");
					} else {
						this.notificationStore.showNotification("generic-fail");
					}
					this.$refs["invoices-table"].fetchData();
					this.emittingCreditNoteId = null;
					this.pendingCreditNoteInvoiceId = null;
				});
			}
		},
		printInvoice(invoiceId) {

			API.init().printInvoice(this.userStore.currBusinessId, invoiceId, (response) => {
				if (response && response.result === 'OK') {
					this.notificationStore.showNotification("print-success");
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
			});

		},
		downloadInvoiceXml(invoice) {

			API.init().downloadInvoiceXml(this.userStore.currBusinessId, invoice.invoice_id, (response) => {
				if(response) {
					//Download the file
					const url = window.URL.createObjectURL(new Blob([response]));
					const link = document.createElement('a');
					const countryPart = this.userStore.currBusiness?.country || '';
					let vatPart = this.userStore.currBusiness?.vat || this.userStore.currBusiness?.fiscal_code;
					vatPart = vatPart || invoice.vat || invoice.cf;
					let idPart = invoice.invoice_id || '';
					if(typeof idPart !== "string") {
						idPart = ''+idPart;
					}
					idPart = idPart.slice(-5);
					// cod. paese + identificativo fiscale (vat o cf) + '_' + progressivo univoco alfanumerico max 5 caratteri .xml
					const fileName = countryPart + vatPart + `_${idPart}.xml`;
					link.setAttribute('href', url);
					link.setAttribute('download', fileName);
					link.click();
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
			});

		},
		downloadInvoicesXml() {

			let invoicesIds = (this.administrationStore?.businessBusinessToCustomerInvoices || []).map(invoice => invoice.apifattura_invoice_id);
			API.init().downloadInvoicesXml(this.userStore.currBusinessId, invoicesIds, (response) => {
				if(response && response?.result !== 'KO') {
					//Download the file
					const url = window.URL.createObjectURL(new Blob([response], {type: 'application/zip'}));
					const link = document.createElement('a');
					link.setAttribute('href', url);
					link.setAttribute('download', `invoices.zip`);
					link.click();
				} else {
					this.notificationStore.showNotification("generic-fail");
				}
			});

		},
		exportInvoices(expExtension) {
			let sym = this.currencyStore.currCurrency.symbol;
			let businessNameNorm = this.userStore.currBusiness.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, "");
			let dateStr = new Date().toLocaleDateString('it-IT').replace(/\//g, '-');
			let fileName = businessNameNorm + "_b2c_invoices_" + dateStr;
			exportToFile({
				columns: [
					{ header: this.getString('date'), value: inv => inv.date ? inv.date.toLocaleString(this.languageStore?.lang || 'it', {year: '2-digit', month: '2-digit', day: 'numeric', hour: '2-digit', minute:'2-digit', hour12: false}) : '' },
					{ header: this.getString('number'), value: inv => inv.numero || '' },
					{ header: this.getString('amount') + ' ' + sym, value: inv => this.currencyStore.dbToActualValue(inv.amount), type: 'number', numberFormat: '#,##0.00' },
					{ header: this.getString('payment'), value: inv => this.getString(inv.payment_type ? 'payment_type_' + inv.payment_type : '') },
					{ header: this.getString('type'), value: inv => this.getString(!!inv.reference_invoice_id ? 'credit_note' : 'invoice') },
					{ header: this.getString('customer'), value: inv => inv.name || '' },
					{ header: this.getString('state'), key: 'state_readable' },
				],
				rows: this.administrationStore?.businessBusinessToCustomerInvoices || [],
				fileName,
				sheetName: this.getString('b2c_invoices'),
				format: expExtension,
				onEmpty: () => this.notificationStore.showNotification('table-no-data'),
				onError: () => this.notificationStore.showNotification('generic-fail'),
			});
		},
	},
	watch: {
		'userStore.currBusinessId': {
			handler(newVal, oldVal) {
				if(newVal && newVal !== oldVal) {
					if(this.$refs['invoices-table']) {
						this.$refs['invoices-table'].fetchData();
					}
				}
			},
		},
	}
}
</script>

<style lang="scss" scoped>
a:after {
	content: none;
}
.container-actions {
	display: flex;
	align-items: center;
	gap: 5px;
}
.no-download {
	font-size: 12px;
}
</style>
